/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckGeneralError } from './PaxCheckGeneralError';
import {
    PaxCheckGeneralErrorFromJSON,
    PaxCheckGeneralErrorFromJSONTyped,
    PaxCheckGeneralErrorToJSON,
    PaxCheckGeneralErrorToJSONTyped,
} from './PaxCheckGeneralError';
import type { PaxCheckApplyDocumentError } from './PaxCheckApplyDocumentError';
import {
    PaxCheckApplyDocumentErrorFromJSON,
    PaxCheckApplyDocumentErrorFromJSONTyped,
    PaxCheckApplyDocumentErrorToJSON,
    PaxCheckApplyDocumentErrorToJSONTyped,
} from './PaxCheckApplyDocumentError';

/**
 * 
 * @export
 * @interface PaxCheckApplyTravelDocumentResponseError
 */
export interface PaxCheckApplyTravelDocumentResponseError {
    /**
     * 
     * @type {PaxCheckGeneralError}
     * @memberof PaxCheckApplyTravelDocumentResponseError
     */
    generalError?: PaxCheckGeneralError;
    /**
     * 
     * @type {PaxCheckApplyDocumentError}
     * @memberof PaxCheckApplyTravelDocumentResponseError
     */
    operationError: PaxCheckApplyDocumentError;
}

/**
 * Check if a given object implements the PaxCheckApplyTravelDocumentResponseError interface.
 */
export function instanceOfPaxCheckApplyTravelDocumentResponseError(value: object): value is PaxCheckApplyTravelDocumentResponseError {
    if (!('operationError' in value) || value['operationError'] === undefined) return false;
    return true;
}

export function PaxCheckApplyTravelDocumentResponseErrorFromJSON(json: any): PaxCheckApplyTravelDocumentResponseError {
    return PaxCheckApplyTravelDocumentResponseErrorFromJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyTravelDocumentResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'generalError': json['general_error'] == null ? undefined : PaxCheckGeneralErrorFromJSON(json['general_error']),
        'operationError': PaxCheckApplyDocumentErrorFromJSON(json['operationError']),
    };
}

export function PaxCheckApplyTravelDocumentResponseErrorToJSON(json: any): PaxCheckApplyTravelDocumentResponseError {
    return PaxCheckApplyTravelDocumentResponseErrorToJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResponseErrorToJSONTyped(value?: PaxCheckApplyTravelDocumentResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'general_error': PaxCheckGeneralErrorToJSON(value['generalError']),
        'operationError': PaxCheckApplyDocumentErrorToJSON(value['operationError']),
    };
}

